(function () {
    'use strict';

    angular.module('app').factory('base64Service', Base64Service);

    Base64Service.$inject = ["saveAs",];
    function Base64Service(saveAs) {

        return {
            convertArrayBufferToBase64String: convertArrayBufferToBase64String,
            SaveBase64File: saveBase64File,
            toArrayBuffer: toArrayBuffer,
            toByteArray,
        };

        function convertArrayBufferToBase64String(buffer) {
            let binary = '';
            let bytes = new Uint8Array(buffer);
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return btoa(binary);
        }

        function saveBase64File(attachment) {
            if (!attachment || !attachment.Content || !attachment.Name)
                return;

            // Invert btoa operation
            const byteCharacters = atob(attachment.Content);
            // Get byte numbers from the byteCharacters
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const blob = new Blob([new Uint8Array(byteNumbers)]);
            saveAs(blob, attachment.Name);
        }

        function toArrayBuffer(base64) {
            if (!angular.isString(base64))
                return;

            const binaryString = atob(base64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes.buffer;
        }

        function toByteArray(base64String) {
            const byteCharacters = atob(base64String);
            // Get byte numbers from the byteCharacters
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }

            return byteArray;
        }
    }
})();